import { useEffect } from 'react';

const SITE_NAME = 'zkb.bio';
const SITE_URL = 'https://zkb.bio';

interface PageMetaProps {
  title: string;
  description: string;
  /** 路由路径，如 "/cv"；用于 og:url */
  path?: string;
}

// 更新（而非新增）head 里的标签：index.html 保留一份站点级兜底
// 供不执行 JS 的爬虫使用，这里原地覆盖为当前页面的值，避免重复标签。
function upsertMeta(selector: string, create: () => HTMLMetaElement, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(selector);
  if (!el) {
    el = create();
    document.head.appendChild(el);
  }
  el.setAttribute('content', content);
}

function namedMeta(name: string) {
  return () => {
    const el = document.createElement('meta');
    el.setAttribute('name', name);
    return el;
  };
}

function propertyMeta(property: string) {
  return () => {
    const el = document.createElement('meta');
    el.setAttribute('property', property);
    return el;
  };
}

export default function PageMeta({ title, description, path }: PageMetaProps) {
  useEffect(() => {
    const fullTitle = `${title} · ${SITE_NAME}`;
    document.title = fullTitle;
    upsertMeta('meta[name="description"]', namedMeta('description'), description);
    upsertMeta('meta[property="og:title"]', propertyMeta('og:title'), fullTitle);
    upsertMeta('meta[property="og:description"]', propertyMeta('og:description'), description);
    if (path !== undefined) {
      upsertMeta('meta[property="og:url"]', propertyMeta('og:url'), `${SITE_URL}${path}`);
    }
  }, [title, description, path]);

  return null;
}
